import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxBodyCell, RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import type { Project } from '@ztechapps/common.contract'
import { useProjectListContext } from './Context'
import { DataListRow } from './DataListRow'

export const ListRow = (props: BodyRowConfig<EntityWithSelection<Project>>) => {
  const { _id, _selected } = props
  const { projectListWithSelection } = useProjectListContext()
  const { toggleSelectBy } = projectListWithSelection

  return (
    <>
      <RowNumberBodyCell {...props} />
      <CheckboxBodyCell
        checked={_selected}
        onChange={() => {
          toggleSelectBy((item) => item._id === _id)
        }}
      />

      <DataListRow {...props} />
    </>
  )
}
